import { lazy } from 'react';

// ----------------------------------------------------------------------

const CheckupPage = lazy(() => import('../pages/Checkup.page'));
const CheckupDetailsPage = lazy(() => import('../pages/CheckupDetailsPage'));
const AddCheckupPage = lazy(() => import('../pages/AddCheckup.page'));
const EditCheckupPage = lazy(() => import('../pages/EditCheckupPage'));

// ----------------------------------------------------------------------

const CheckupListRoutes = [
    {
        path: '/checkup',
        children: [
            { element: <CheckupPage />, layout: 'default', isAuthReq: true, index: true },
            {
                path: '/checkup/create',
                element: <AddCheckupPage />,
                layout: 'default',
                isAuthReq: true,
            },
            { path: 'edit/:id', element: <EditCheckupPage />, layout: 'default', isAuthReq: true },
            { path: 'order-list/:id', element: <CheckupDetailsPage />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { CheckupListRoutes };
